import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid, IconButton, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import UpdateUser from "../UpdateUser";
import UserList from "../UserList";
import Success from "components/Success";
import { usersApi, updateUsersApi, usersDetailsApi } from "store/api";
import { useNavigate } from "react-router";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function UserTab () {
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [updateUser, setUpdateUser] = React.useState({});

  const handleClickOpenUpdate = data => {
    setUpdateUser(data);
    setOpenUpdate(true);
  };
  
  const handleCloseUpdate = () => {
    setOpenUpdate(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);

  const handleSubmitUpdate = async e => {
    e?.preventDefault();
    let apiData = {
      userId: updateUser.userId,
      accountStatus: updateUser.accountStatus,
    };
    const response = await updateUsersApi(apiData);
    if (response?.success) {
      setMsg("Update user status successfully");
      setSuccess(true);
      setOpen(true);
      FetchUsers();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    handleCloseUpdate();
  };

  const handleChangeUpdateUser = e => {
    const { name, value } = e.target;
    setUpdateUser(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const [users, setUsers] = React.useState([]);

  // Fetch API results
  const FetchUsers = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          keyword: searchTerm,
        };
    try {
      const response = await usersApi(params);
      if (response?.success) {
        setUsers(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChangeUser = async e => {
    const { value } = e.target;
    if (debounceTimeout) clearTimeout(debounceTimeout);
    const newTimeout = setTimeout(() => {
      FetchUsers(value);
    }, 500);
    setDebounceTimeout(newTimeout);
  };

  React.useEffect(() => {
    FetchUsers();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5' onClick={()=> navigate('/user-details')}>Users</Typography>
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeUser}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All' {...a11yProps(0)} />
            <Tab label='Active' {...a11yProps(1)} />
            <Tab label='Pending' {...a11yProps(2)} />
            <Tab label='Restricted' {...a11yProps(3)} />
            <Tab label='Banned' {...a11yProps(4)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {users?.length == 0 && <div>No User found</div>}
            {users?.length > 0 && (
              <UserList users={users} active={0} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {users?.length == 0 && <div>No User found</div>}
            {users?.length > 0 && (
              <UserList users={users} active={1} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {users?.length == 0 && <div>No User found</div>}
            {users?.length > 0 && (
              <UserList users={users} active={2} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {users?.length == 0 && <div>No User found</div>}
            {users?.length > 0 && (
              <UserList users={users} active={3} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={4} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {users?.length == 0 && <div>No User found</div>}
            {users?.length > 0 && (
              <UserList users={users} active={4} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
      </Box>
      <UpdateUser
        open={openUpdate}
        handleClose={handleCloseUpdate}
        handleSubmit={handleSubmitUpdate}
        updateUserData={updateUser}
        handleChangeUpdateUser={handleChangeUpdateUser}
      />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}
